<footer>
  <div class="footer-contacto">
    <span class="textoFooter2">
      <i class="fas fa-phone-square" aria-hidden="true"></i>
      <span class="phone">902 23 55 23</span>
    </span>

    <span class="textoFooter">ACTECO Productos y Servicios, S.L.</span><br>

    <span class="textoFooter2">
      <i class="fa fa-envelope" aria-hidden="true"></i>
      <span class="mail">acteco&#64;acteco.net</span>
    </span>

    <span class="textoFooter">
      P.I. L'Alfaç, c/Zamora 24. CP: 03440 IBI (Alicante)
    </span>
  </div>
</footer>
